var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeHygienic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.793 14.288L4.26 10.742a.71.71 0 01.001-1.003l.603-.6a.71.71 0 011.004 0l2.427 2.438 6.59-6.59a.708.708 0 011.003 0l.602.602a.709.709 0 010 1.003l-7.695 7.696a.709.709 0 01-1.003 0z",
    fill: "#45355C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.61 9.762c-.674 2.938-2.276 5.563-6.056 8.337a.415.415 0 01-.46 0c-5.731-4.205-6.465-8.061-6.529-13.197a.374.374 0 01.273-.35c2.816-.696 5.14-1.991 6.246-2.681a.495.495 0 01.48 0 23.39 23.39 0 004.267 2.07.49.49 0 00.468-.106L14.134 3c.111-.11.079-.237-.07-.285C11.04 1.744 8.805.165 8.779.145a.781.781 0 00-.909 0C7.838.17 4.597 2.463.634 3.222A.78.78 0 000 3.986C0 9.891.58 14.81 7.88 19.861a.773.773 0 00.888 0c5.611-3.884 7.247-7.69 7.706-11.925.016-.155-.061-.192-.172-.081l-1.431 1.43a1.15 1.15 0 00-.262.477z",
    fill: "#45355C"
  })));
}
export default SvgSafeHygienic;